package com.flowyride.core.designsystem.component

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.flowyride.core.designsystem.theme.FlowyColors

/** Colors offered for a saved address, 0xRRGGBB; the first one is the default. */
val SavedPlaceColors: List<Int> = listOf(
    0xC62828, // red, like the arrival
    0xE65100, // the route's orange
    0xF9A825,
    0x2E7D32,
    0x00838F,
    0x1565C0,
    0x6A1B9A,
    0xAD1457,
    0x4E342E,
    0x455A64,
)

/** 0xRRGGBB (null: the default) as a Compose color. */
fun savedPlaceColor(rgb: Int?): Color = if (rgb == null) FlowyColors.Arrival else Color(0xFF000000 or rgb.toLong())

/**
 * How a saved address shows, on its chip, in the settings and on the map: its emoji on a white disc ringed with
 * its color, or a plain dot of its color.
 */
@Composable
fun SavedPlaceBadge(emoji: String?, color: Int?, modifier: Modifier = Modifier, size: Dp = 28.dp) {
    val tint = savedPlaceColor(color)
    if (emoji == null) {
        Canvas(modifier.size(size)) {
            drawCircle(Color.White)
            drawCircle(tint, radius = this.size.minDimension / 2 - (this.size.minDimension * 0.15f))
        }
        return
    }
    val fontSize = with(LocalDensity.current) { (size * 0.55f).toSp() }
    Box(
        modifier
            .size(size)
            .background(Color.White, CircleShape)
            .border((size * 0.09f).coerceAtLeast(1.5.dp), tint, CircleShape),
        contentAlignment = Alignment.Center,
    ) {
        Text(emoji, fontSize = fontSize, maxLines = 1)
    }
}
